import data from "../somos.json";
console.log(data[0]);
// => "world"

// 1. Importamos los datos del archivo JSON
import data from "../somos.json";

// 2. Seleccionamos de forma aleatoria 3 items del array de objetos
const selectedItems = shuffleArray(data).slice(0, 3);

// 3. Colocamos esos ids y esas imágenes en los contenedores de imagenes (#contendorImages1, #contendorImages2 y #contenedorImágenes3)
const contenedor1 = document.getElementById("contendorImages1");
const contenedor2 = document.getElementById("contendorImages2");
const contenedor3 = document.getElementById("contendorImages3");

if (contenedor1 && contenedor1.children && contenedor1.children.length < 1) {
  contenedor1.appendChild(img);
  img.addEventListener("click", () => showModal(item));
} else {
  console.log("no encuentro el contendorImages1");
}
selectedItems.forEach((item) => {
  const img = document.createElement("img");
  img.src = item.src;
  img.alt = item.titulo;

  if (contenedor1.children.length < 1) {
    contenedor1.appendChild(img);
    img.addEventListener("click", () => showModal(item));
  } else if (contenedor2.children.length < 1) {
    contenedor2.appendChild(img);
    img.addEventListener("click", () => showModal(item));
  } else if (contenedor3.children.length < 1) {
    contenedor3.appendChild(img);
    img.addEventListener("click", () => showModal(item));
  }
});

// 4. Al hacer click en el contenedor de imagenes recogeremos el id y recuperaremos los datos del archivo json que colocaremos en un modal y después lo mostraremos.
function showModal(item) {
  const modalTitle = document.getElementById("modalTitle");
  const modalBody = document.getElementById("modalBody");

  modalTitle.textContent = item.titulo;

  if (item.tipo === "imagen") {
    const img = document.createElement("img");
    img.src = item.archivo;
    img.classList.add("img-fluid", "mx-auto");
    modalBody.innerHTML = "";
    modalBody.appendChild(img);
  } else if (item.tipo === "video") {
    const video = document.createElement("video");
    video.src = item.archivo;
    video.setAttribute("controls", "");
    video.setAttribute("preload", "");
    video.style.width = "100%";
    video.style.height = "auto";
    video.classList.add("mx-auto");
    modalBody.innerHTML = "";
    modalBody.appendChild(video);
  }

  const modalText = document.createElement("p");
  modalText.innerHTML = item.texto;
  modalBody.appendChild(modalText);

  const modal = new bootstrap.Modal(document.getElementById("myModal"));
  modal.show();
}

// Función para mezclar el orden de los elementos de un array
function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}
